module.exports = __webpack_public_path__ + "static/img/picc.93fa6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/daysurgery/assets/picc.png
// module id = 345
// module chunks = 379 380